import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Bloqueia datas futuras (ex.: data de pagamento). Como é um Validator normal ligado ao FormControl,
 * o Angular já recalcula e limpa o erro sozinho a cada mudança de valor — não precisa de lógica manual
 * de "limpar a borda vermelha".
 */
export class FutureDateValidator {
  static notFuture(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const valor = new Date(control.value);
      if (isNaN(valor.getTime())) return null;

      const hoje = new Date();
      hoje.setHours(23, 59, 59, 999);

      return valor > hoje ? { dataFutura: true } : null;
    };
  }
}
